export default {"src":"/_next/static/media/buyback-price.00df4993.svg","height":202,"width":215};